export default __webpack_public_path__ + "static/media/img.ebe3ad68.png";